export default __webpack_public_path__ + "static/media/hk.f032f0ae.svg";